import Constant from '@/common/constant/Constant';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { setPanelSelector } from '@/state/selector/panelSelector';
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import React, { useEffect, useState } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { isOpenButtonCreateTicket } from '../handler/TicketListHandler';
import './ViewTabs.css';
import { isSetDefaultPanelAtom } from '@/state/atom/panelAtom';
import { Popover, Tooltip } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { I18n } from 'aws-amplify';
import { userAtom } from '@/state/atom/userAtom';
import { isShowExternalDeskRequestSystemForm } from '../handler/ExternalQaTicketHandler';
import { formListOfProjectSelector } from '@/state/selector/formSelector';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { permissionCreateTicketExternalDeskRequest, permissionCreateTicketInviteGuestDesk } from '@/component/common/layout/addTicket/handler/AddTicketHandler';

function a11yProps(type) {
    return {
        id: `scrollable-auto-tab-${type}`,
        'aria-controls': `scrollable-auto-tabpanel-${type}`,
    };
}

export default function ViewTabs(props) {
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const isSetDefaultPanel = useRecoilValue(isSetDefaultPanelAtom);

    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const userDetail = useRecoilValue(userAtom);
    const [currentCorporationFormList, setCurrentCorporationFormList] = useRecoilState(
        formListOfProjectSelector
    );
    const [corporationDetail, setCorporationDetail] = useRecoilState(corporationAtom);

    const [formTypePopover, setFormTypePopover] = useState(null);
    const isOpenFormTypePopover = Boolean(formTypePopover);

    const handleAddPanel = (e, selectedTicketType) => {
        addNewPanel( {
            type: Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL,
            tabId: `QA_NEW_TICKET_TAB_${Date.now().toString()}`,
            props,
            selectedTicketType
        });
        setFormTypePopover(null)
    };

    const handleOptionsTicketTypeToCreate = (e) => {
        if (!isShowOptionInvite()) {
            handleAddPanel(e, Constant.QA_CREATE_TICKET_TYPE.QA);
            return;
        }
        setFormTypePopover(e.currentTarget)
    }

    const handleChangeView = (event, newValue) => {
        props.setViewSelected(newValue);

        switch (newValue) {
            case Constant.CUSTOMER_SIDE_VIEW.IN_CHARGE_QA_VIEW:
                props.setFilterStatus(Constant.QA_FILTER_STATUS.SENT);
                props.setFilterCreator(Constant.QA_FILTER_CREATOR.PROJECT_MEMBER);
                props.setFilterHelpDesk('');
                props.setFilterHelpDeskNotice('');
                break;
            case Constant.CUSTOMER_SIDE_VIEW.DRAFT_QA_VIEW:
                props.setFilterStatus(Constant.QA_FILTER_STATUS.DRAFT);
                props.setFilterCreator(Constant.QA_FILTER_CREATOR.ME);
                props.setFilterHelpDesk('');
                props.setFilterHelpDeskNotice('');
                break;
            case Constant.CUSTOMER_SIDE_VIEW.ARCHIVE_QA_VIEW:
                props.setFilterStatus(Constant.QA_FILTER_STATUS.ARCHIVE);
                props.setFilterCreator(Constant.QA_FILTER_CREATOR.ALL);
                props.setFilterHelpDesk('');
                props.setFilterHelpDeskNotice('');
                break;
            case Constant.CUSTOMER_SIDE_VIEW.NOTICE_VIEW:
                props.setFilterStatus(Constant.QA_FILTER_STATUS.SENT);
                props.setFilterCreator('');
                props.setFilterHelpDesk('');
                props.setFilterHelpDeskNotice('');
                break;
            case Constant.CUSTOMER_SIDE_VIEW.INVITATION_VIEW:
                props.setFilterStatus(Constant.QA_FILTER_STATUS.SENT);
                props.setFilterCreator('');
                props.setFilterHelpDesk('');
                props.setFilterHelpDeskNotice('');
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (isSetDefaultPanel) {
            addNewPanel({
                type: Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL,
                tabId: `QA_NEW_TICKET_TAB_${Date.now().toString()}`,
                props,
            });
        }
    }, [])

    const formExternalDeskRequestInfo = isShowExternalDeskRequestSystemForm(
        Constant.EXTERNAL_REQUEST_TYPE.DESK_REQUEST,
        Constant.FORM_TYPE.FORM_REQ_EXTERNAL_DESK,
        currentCorporationFormList,
        projectInuseDetail
    );

    const formInviteGuestDeskInfo = isShowExternalDeskRequestSystemForm(
        Constant.EXTERNAL_REQUEST_TYPE.DESK_REQUEST,
        Constant.FORM_TYPE.FORM_REQ_INVITE_GUESTDESK,
        currentCorporationFormList,
        projectInuseDetail
    );

    const isShowOptionInvite = () => {
        return (permissionCreateTicketExternalDeskRequest(
            userDetail,
            projectInuseDetail.type,
            formExternalDeskRequestInfo.status,
            corporationDetail.contractType
        ) ||
            permissionCreateTicketInviteGuestDesk(
                userDetail,
                projectInuseDetail.type,
                formInviteGuestDeskInfo.status,
                corporationDetail.limitValue?.numOfGuestDesk,
                corporationDetail.contractType
        ))
    }

    return (
        <div className="tabs-info">
            <div className="tabs-wrap" data-cy="tabs-wrap" style={{justifyContent: 'space-between', gap:'10px'}}>
                <div className="navTabs navTabs-qa" >
                    <AppBar className="navTabs-box" position="static" style={{maxWidth: '100%'}}>
                        <Tabs
                            className="navTabs-rot"
                            value={props.viewSelected}
                            onChange={handleChangeView}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs example"
                        >
                            <Tab
                                data-cy="tab-internal-qa"
                                className="navTabs--item nav-Tabs-flex"
                                label={
                                    <OverFlowTooltipWithTabsMui value="新規問い合わせ"/>
                                }
                                value={Constant.CUSTOMER_SIDE_VIEW.IN_CHARGE_QA_VIEW}
                                {...a11yProps('IN_CHARGE_VIEW')}
                            />
                            <Tab
                                data-cy="tab-internal-qa"
                                className="navTabs--item nav-Tabs-flex"
                                label={
                                    <OverFlowTooltipWithTabsMui value="お知らせ"/>
                                }
                                value={Constant.CUSTOMER_SIDE_VIEW.NOTICE_VIEW}
                                {...a11yProps('NOTICE_VIEW')}
                            />
                            <Tab
                                data-cy="tab-internal-qa"
                                className="navTabs--item nav-Tabs-flex"
                                label={
                                    <OverFlowTooltipWithTabsMui value="下書き"/>
                                }
                                value={Constant.CUSTOMER_SIDE_VIEW.DRAFT_QA_VIEW}
                                {...a11yProps('DRAFT_VIEW')}
                            />
                            <Tab
                                data-cy="tab-internal-qa"
                                className="navTabs--item nav-Tabs-flex"
                                label={
                                    <OverFlowTooltipWithTabsMui value="アーカイブ"/>
                                }
                                value={Constant.CUSTOMER_SIDE_VIEW.ARCHIVE_QA_VIEW}
                                {...a11yProps('ARCHIVE_VIEW')}
                            />
                            {projectInuseDetail?.type !== Constant.PROJECT_TYPE.BASE && (
                                <Tab
                                    data-cy="tab-internal-qa"
                                    className="navTabs--item nav-Tabs-flex"
                                    label={
                                        <OverFlowTooltipWithTabsMui value="申請チケット"/>
                                    }
                                    value={Constant.CUSTOMER_SIDE_VIEW.INVITATION_VIEW}
                                    {...a11yProps('INVITATION_VIEW')}
                                />
                            )}
                        </Tabs>
                    </AppBar>
                </div>
                {props.isCreateTicket && isOpenButtonCreateTicket(userDetail, props.contractType, props.ticketListType, projectInuseDetail) && (
                    <>
                        <Tooltip title="新規作成">
                            <button className='btn-add-ticket'  onClick={e => handleOptionsTicketTypeToCreate(e)}>
                                <img src="/assets/image/icon-add-ticket.svg" alt="icon-add-ticket" />
                                <span className='text-add-ticket'>作成</span>
                            </button>
                        </Tooltip>
                        <Popover
                            className="ticket-types-manager"
                            style={{ width: 'auto' }}
                            id={isOpenFormTypePopover ? 'simple-popover' : undefined}
                            open={isOpenFormTypePopover}
                            anchorEl={formTypePopover}
                            onClose={() => setFormTypePopover(null)}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left'
                            }}
                        >
                            <ul>
                               
                                <li
                                    className="active"
                                    onClick={e =>
                                        handleAddPanel(
                                            e,
                                            Constant.QA_CREATE_TICKET_TYPE.QA
                                        )
                                    }
                                >
                                    <span className="text">
                                        {I18n.get('FIELDFORMBTN007')}
                                    </span>
                                </li>
                                {isShowOptionInvite() && (
                                    <>
                                        <li
                                            onClick={e =>
                                                handleAddPanel(
                                                    e,
                                                    Constant.QA_CREATE_TICKET_TYPE.INVITATION
                                                )
                                            }
                                        >
                                            <span className="text">
                                                {I18n.get('USER04BTN009')}
                                            </span>
                                        </li>
                                    </>
                                )}
                            </ul>
                        </Popover>
                    </>  
                )}
            </div>
        </div>
    );
}
